<template>
  <b-row>
    <b-col>
      <chartjs-container title="Demandes d'hébergement">
        <chartjs-component-horizontal-bar-chart
          v-if="hasMeaningfulData"
          :height="chartHeight"
          :chart-data="chartData"
        />
        <p v-else>
          Aucune donnée disponible pour la période sélectionnée.
        </p>
      </chartjs-container>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCol,
  BRow,
} from 'bootstrap-vue'
import ChartjsContainer from '../ChartjsContainer.vue'
import ChartjsComponentHorizontalBarChart from '../charts-components/ChartjsComponentHorizontalBarChart.vue'
import useStatisticsRouteFetch from '../useStatisticsRouteFetch'
import {
  computedConfiguration,
  watchConfiguration,
  BASE_CHART_HEIGHT,
  chartHasMeaningfulData,
  TABS,
  CHART_COLORS,
} from './baseConfiguration'

export default {
  components: {
    BCol,
    BRow,
    ChartjsContainer,
    ChartjsComponentHorizontalBarChart,
  },
  data() {
    return {
      tabname: TABS.ACCOMMODATION_REQUEST,
      chartData: {},
      chartHeight: BASE_CHART_HEIGHT,
    }
  },
  computed: {
    ...computedConfiguration,
    hasMeaningfulData() {
      return chartHasMeaningfulData(this.chartData)
    },
  },
  watch: watchConfiguration,
  methods: {
    fetchRouteOnActive() {
      if (this.active) {
        this.fetchRoute()
      }
    },
    async fetchRoute() {
      const response = await useStatisticsRouteFetch()
      this.buildChart(response)
    },
    buildChart(data) {
      if (!data) {
        this.chartData = {}
        return
      }

      const entries = Object.values(data)
      const labels = entries.map(e => e.label)
      const values = entries.map(e => e.value)

      if (values.every(v => v === 0)) {
        this.chartData = {}
        return
      }

      this.chartData = {
        labels,
        datasets: [{
          label: "Demandes d'hébergement",
          data: values,
          backgroundColor: [
            CHART_COLORS.BRAND.PRIMARY,
            CHART_COLORS.BRAND.SECONDARY,
            CHART_COLORS.BRAND.ACCENT_RED,
            CHART_COLORS.BRAND.ACCENT_ORANGE,
          ],
          barThickness: 30,
        }],
      }
    },
  },
}
</script>
